import { render, staticRenderFns } from "./CrFooter.vue?vue&type=template&id=6e6d7024&scoped=true"
import script from "./CrFooter.vue?vue&type=script&lang=js"
export * from "./CrFooter.vue?vue&type=script&lang=js"
import style0 from "./CrFooter.vue?vue&type=style&index=0&id=6e6d7024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d7024",
  null
  
)

export default component.exports